/**
 * کاور مقاله — قاب با ارتفاع ثابت (کلاس‌ها همین فایل برای Tailwind).
 * card: لیست و پروفایل | detail: صفحهٔ جزئیات
 */
export default function PublicationCoverImage({
	src,
	alt = "",
	variant = "card",
	className = "",
}) {
	const frameClass =
		variant === "detail"
			? "h-[220px] md:h-[280px]"
			: "h-[180px] sm:h-[200px]";

	return (
		<div
			className={[
				"w-full min-w-0 max-w-full shrink-0 overflow-hidden rounded-[10px] bg-lightCta",
				frameClass,
				className,
			].join(" ")}
		>
			{src ? (
				<img
					src={src}
					alt={alt}
					loading="lazy"
					decoding="async"
					className="block h-full w-full max-w-full object-contain object-center p-2 sm:p-3"
				/>
			) : (
				<div className="flex h-full items-center justify-center text-darkBlue/40">
					—
				</div>
			)}
		</div>
	);
}
